// https://addyosmani.com/resources/essentialjsdesignpatterns/book/#observerpatternjavascript

/**
 * Провайдер запросов Axios (любых внешних).
 * Создает синглтон, чтобы все запросы шли через 1 точку
 */
class PubSub {
  private constructor() {
    this.topics = {};
    this.subUid = -1;

    return this;
  }

  public topics: Record<
    string,
    {
      token: string;
      func: (topic: string, args: any) => void;
    }[]
  >;

  public subUid: number;

  private static instance: PubSub;

  /**
   * Метод, возвращающий единичный экземпляр синглтона
   * @returns Возвращает провайдер каталита для вызова запросов
   */
  public static getInstance(): PubSub {
    if (!PubSub.instance) {
      PubSub.instance = new PubSub();
    }

    return PubSub.instance;
  }

  // Publish or broadcast events of interest
  // with a specific topic name and arguments
  // such as the data to pass along
  public publish(topic: string, args?: any): PubSub | boolean {
    if (!this.topics[topic]) {
      return false;
    }

    const subscribers = this.topics[topic];
    let len = subscribers ? subscribers.length : 0;

    while (len--) {
      subscribers[len].func(topic, args);
    }

    return this;
  }

  // Subscribe to events of interest
  // with a specific topic name and a
  // callback function, to be executed
  // when the topic/event is observed
  public subscribe(topic: string, func: any): string {
    if (!this.topics[topic]) {
      this.topics[topic] = [];
    }

    const token = (++this.subUid).toString();
    this.topics[topic].push({
      token: token,
      func: func,
    });
    return token;
  }

  // Unsubscribe from a specific
  // topic, based on a tokenized reference
  // to the subscription
  public unsubscribe(token: string, topic: string): PubSub | string {
    for (const m in this.topics) {
      if (this.topics[m]) {
        for (let i = 0, j = this.topics[m].length; i < j; i++) {
          if (this.topics[m][i].token === token && m === topic) {
            this.topics[m].splice(i, 1);
            return token;
          }
        }
      }
    }
    return this;
  }

  public unsubscribeAll(token: string) {
    this.topics[token] = [];
  }
}

// Необходимо для итмпорта в ES6
export const pubsub = () => {
  return PubSub.getInstance();
};

// Необходимо для итмпорта в ES5
export default PubSub.getInstance();
